export const TYPE = {
    PRICE: 'price',
    SERVICE: 'service'
};
